import { isObject } from './type-guards';

export function isRecord<TKey extends string | number | symbol, TValue>(): (
  value: unknown,
) => value is Record<TKey, TValue> {
  return (value): value is Record<TKey, TValue> => isObject(value);
}
